<template>
  <div class="sort-dropdown">
    <a :uk-tooltip="title || $t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover btn-circle" href="#">
      <i class="uil-list-ui-alt" />
    </a>
    <div ref="dropdownModalRef" class="uk-dropdown sort-dropdown__menu"
        uk-dropdown="pos: bottom-right; mode: click; animation: uk-animation-scale-up">
      <ul class="uk-nav uk-dropdown-nav">
        <li v-for="option in sortOptions" :key="option.key" @click="handleSort(option.sort, option.order)">
          <a href="javascript:void(0)">{{ option.label }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SortDropdown",
  props: {
    sortOptions: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleSort(sort, order) {
      this.$emit("sort-selected", {sort, order});

      const dropdown = this.$refs.dropdownModalRef;
      if (dropdown) {
        UIkit.dropdown(dropdown).hide();
      }
    },
  },
};
</script>

<style scoped>
.sort-dropdown {
  position: relative;
}

/* Menu, kart ve sekme kapsayicilarindaki `overflow: hidden` tarafindan
   kesiliyordu (tablo bosken kart kisa kaldigi icin cok belirgin). `fixed`
   ile kapsayicinin kirpma alanindan cikar; UIkit konumu mevcut konuma gore
   delta hesapladigi icin butonun altindaki hizalama bozulmaz. `top/left: 0`
   tabani sart: deger `auto` kalirsa delta hesabi sapar. */
.sort-dropdown__menu {
  position: fixed;
  top: 0;
  left: 0;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
}
</style>
